/**
 * Created by Ning Jiang on 2/7/2019.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {IntroFeatureLogo} from "@nolimitcity/slot-game/bin/core/gameintro/GameIntroView";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {PickAndClickController} from "@nolimitcity/slot-game/bin/core/pickandclick/PickAndClickController";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelPartAnimator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartAnimator";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolSizeConfig, ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ScreenController} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IndividualWinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {FreespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/FreespinZeroBetController";
import {PPBackground} from "./background/PPBackground";
import {BattleMeterController} from "./battle/meter/BattleMeterController";
import {PPMidSymbolsIdleAnimationController} from "./idle/PPMidSymbolsIdleAnimationController";
import {ScatterIdleAnimationController} from "./idle/ScatterIdleAnimationController";
import {PixiesVsPiratesIntroView} from "./intro/PixiesVsPiratesIntroView";
import {PPPickNClickIntroController} from "./picknclick/intro/PPPickNClickIntroController";
import {PPPickNClickIntroView} from "./picknclick/intro/PPPickNClickIntroView";
import {PPPickNClickOutroController} from "./picknclick/outro/PPPickNClickOutroController";
import {PPPickNClickOutroView} from "./picknclick/outro/PPPickNClickOutroView";
import {PixiesVsPiratesFontConfig} from "./PixiesVsPiratesFontConfig";
import {PixiesVsPiratesGameAssets} from "./PixiesVsPiratesGameAssets";
import {PixiesVsPiratesGameConfig} from "./PixiesVsPiratesGameConfig";
import {PixiesVsPiratesSoundConfig} from "./PixiesVsPiratesSoundConfig";
import {PPReelController} from "./reel/PPReelController";
import {PPReelPartAnimator} from "./reel/PPReelPartAnimator";
import {PPReelDivider} from "./reeldivider/PPReelDivider";
import {BattleCollectController} from "./reelstoppresentation/battlecollect/BattleCollectController";
import {PixiesVsPiratesReelAttentionController} from "./reelstoppresentation/reelattention/PixiesVsPiratesReelAttentionController";
import {ReelExpansionController} from "./reelstoppresentation/reelextention/ReelExpansionController";
import {PPScatterAttentionController} from "./reelstoppresentation/scatterattention/PPScatterAttentionController";
import {WildAttentionController} from "./reelstoppresentation/wildattention/WildAttentionController";
import {PixiesVsPiratesParsedGameData} from "./server/parseddata/PixiesVsPiratesParsedGameData";
import {PixiesVsPiratesParsedInitData} from "./server/parseddata/PixiesVsPiratesParsedInitData";
import {PixiesVsPiratesServerDataParser} from "./server/PixiesVsPiratesServerDataParser";
import {PixiesVsPiratesSoundPlayer} from "./soundPlayer/PixiesVsPiratesSoundPlayer";
import {SpinEffects} from "./spineffect/SpinEffects";
import {PixiesVsPiratesReelSymbol} from "./symbols/PixiesVsPiratesReelSymbol";
import {PixiesVsPiratesReelSymbolStateCreator} from "./symbols/PixiesVsPiratesReelSymbolStateCreator";
import {PPLowSymbol} from "./symbols/PPLowSymbol";
import {PPMidSymbol} from "./symbols/PPMidSymbol";
import {PPScatterSymbol} from "./symbols/PPScatterSymbol";
import {PPWildSymbol} from "./symbols/PPWildSymbol";
import {PixiesVsPiratesBigWinController} from "./winpresentation/bigwin/PixiesVsPiratesBigWinController";
import {PPIndividualWPController} from "./winpresentation/individual/PPIndividualWPController";
import {PixiesVsPiratesInitialWPController} from "./winpresentation/initial/PixiesVsPiratesInitialWPController";
import {PPNoWinSymbolsWinPresentationController} from "./winpresentation/nowin/PPNoWinSymbolsWinPresentationController";
import {PPNudgeWildWPController} from "./winpresentation/nudge/PPNudgeWildWPController";
import {PPScatterWPController} from "./winpresentation/scatter/PPScatterWPController";
import {XWaysIndicatorController} from "./xways/XWaysIndicatorController";

export class PixiesVsPiratesGameModuleConfig implements IGameModuleConfig {

    public static instance:PixiesVsPiratesGameModuleConfig = new PixiesVsPiratesGameModuleConfig();
    public static soundPlayer:PixiesVsPiratesSoundPlayer;
    GAME_CONFIG:IGameConfig = PixiesVsPiratesGameConfig.instance;
    SOUND_CONFIG:ISoundConfig = PixiesVsPiratesSoundConfig.instance;
    FONTS_CONFIG:IFontsConfig = PixiesVsPiratesFontConfig.FONTS;
    RESOURCES_CONFIG:IResourcesGroupConfig = PixiesVsPiratesGameAssets.RESOURCES_GROUPS;

    SERVER_PARSER:() => ServerDataParser = () => new PixiesVsPiratesServerDataParser();

    PARSED_INIT_DATA:(data:any, dataParser:ServerDataParser) => ParsedInitData = (data, dataParser:ServerDataParser) => new PixiesVsPiratesParsedInitData(data, <PixiesVsPiratesServerDataParser>dataParser);
    PARSED_GAME_DATA:(data:any, dataParser:ServerDataParser) => ParsedGameData = (data, dataParser:ServerDataParser) => new PixiesVsPiratesParsedGameData(data, <PixiesVsPiratesServerDataParser>dataParser);

    // REEL_AREA_VIEW:() => ReelAreaView = () => {
    //     return new PixiesVsPiratesReelAreaView();
    // };

    REEL_CONTROLLER:(reelId:number) => ReelController = reelId => new PPReelController(reelId);

    // REEL_VIEW?:(reelId:number) => PIXI.Container; // return type baseView? Default new PIXI.Sprite.

    REEL_PART_ANIMATOR:(reelId:number) => ReelPartAnimator = (reelId) => new PPReelPartAnimator(reelId);

    REEL_PART_CREATOR:() => ReelPartCreator =
        () => new ReelPartCreator(
            (symName:string, reelId:number, state?:ISymbolStateConfig, size?:ISymbolSizeConfig):PixiesVsPiratesReelSymbol => {
                if(symName.indexOf("W") > -1) {
                    return new PPWildSymbol(symName, reelId, state, size);
                }
                if(symName.indexOf("S") > -1) {
                    return new PPScatterSymbol(symName, reelId, state, size);
                }
                if(symName.indexOf("M") > -1) {
                    return new PPMidSymbol(symName, reelId, state, size);
                }
                if(symName.indexOf("L") > -1) {
                    return new PPLowSymbol(symName, reelId, state, size);
                }
                return new PixiesVsPiratesReelSymbol(symName, reelId, state, size);
            });


    SYMBOL_STATE_CREATOR:() => ReelSymbolStateCreator = () => new PixiesVsPiratesReelSymbolStateCreator();

    INTRO_VIEW:(onClickCallback:() => void) => PixiesVsPiratesIntroView =
        (onClickCallback:() => void) => new PixiesVsPiratesIntroView({
            layer : PixiesVsPiratesGameConfig.instance.LAYERS.INTRO.name,
            onButtonClickCallback : onClickCallback,
            resourceGroup : ResourcesGroupName.INTRO,
            backgroundTextures : {
                desktop : {landscape : PixiesVsPiratesGameAssets.INTRO_BACKGROUND},
            },
            featureIcons : {
                icons : [IntroFeatureLogo.X_NUDGE, IntroFeatureLogo.X_WAYS, IntroFeatureLogo.VOLATILITY_EXTREME]
            },
            mobileScale : 1.2,
            portraitScale : 1.8
        });

    PICK_AND_CLICKS:(() => PickAndClickController)[] = [
        () => new PPPickNClickIntroController({
            viewCreator : (onButtonClickCallback:(index:number, auto:boolean) => void, autoClick?:boolean) => {
                return new PPPickNClickIntroView({
                    layer : PixiesVsPiratesGameConfig.instance.LAYERS.FREESPIN_INTRO.name,
                    onButtonClickCallback : onButtonClickCallback,
                    recreateButtons : false
                });
            },
            showWinPresentations : false
        })
    ];

    SCREENS:(() => ScreenController)[] = [
        () => new PPPickNClickOutroController({
            viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                return new PPPickNClickOutroView({
                    layer : PixiesVsPiratesGameConfig.instance.LAYERS.FREESPIN_OUTRO.name,
                    onButtonClickCallback : onButtonClickCallback,
                    mobileScale : 1.2,
                    portraitScale : 1.6
                });
            }
        })
    ];

    ZERO_BETS:(() => ZeroBetController)[] = [
        () => new FreespinZeroBetController()
    ];

    REEL_STOP_PRESENTATIONS:((index:number) => ReelStopPresentationController)[] = [
        index => new PPScatterAttentionController(index, {
            numOfScattersToWin : 3,
            scattersMap : [false, true, true, true, true, false],
            winAttentionSoundName : PixiesVsPiratesSoundConfig.SCATTER_LANDING_3
        }),
        index => new WildAttentionController(index),
        index => new PixiesVsPiratesReelAttentionController(index),
        index => new ReelExpansionController(index),
        index => new BattleCollectController(index)
    ];

    WIN_PRESENTATIONS:((indexes:[number, number]) => WinPresentationController)[][] = [
        [indexes => new PPNudgeWildWPController(indexes)],
        [indexes => new PPNoWinSymbolsWinPresentationController(indexes)],
        [indexes => new PixiesVsPiratesInitialWPController(indexes)],
        [indexes => new PixiesVsPiratesBigWinController(indexes)],
        [indexes => new PPScatterWPController(indexes)],
        [indexes => new BattleMeterController(indexes)]
    ];

    INDIVIDUAL_WIN_PRESENTATION:() => IndividualWinPresentationController =
        () => new PPIndividualWPController({
            symbolTimeOffsetCalculator : (currentTotalDuration:number, reelId:number, symbolId:number):number => {
                return 0.1;
            }
        });

    GAME_FEATURE_CREATOR:() => void = () => {
        PixiesVsPiratesGameModuleConfig.soundPlayer = new PixiesVsPiratesSoundPlayer();
        const background = new PPBackground({
            layer : PixiesVsPiratesGameConfig.instance.LAYERS.BACKGROUND.name,
            backgroundImages : {
                NORMAL : {image : PixiesVsPiratesGameAssets.MAIN_GAME_BACKGROUND, offset : new PIXI.Point(-480, -480)},
                FREESPIN : {
                    image : PixiesVsPiratesGameAssets.FREESPIN_BACKGROUND,
                    offset : new PIXI.Point(-480, -480),
                    scale : 2.35
                },
                FREESPIN_PICK : {
                    image : PixiesVsPiratesGameAssets.FREESPIN_BACKGROUND,
                    offset : new PIXI.Point(-480, -480),
                    scale : 2.35
                }
            },
            stretch : false
        });

        const xWaysReelIndicator = new XWaysIndicatorController();
        const scatterIdleAnimation = new ScatterIdleAnimationController({
            startTime : 0,
            minInterval : 150,
            maxInterval : 250
        });

        const midSymbolIdleAnimation = new PPMidSymbolsIdleAnimationController({
            startTime : 0,
            minInterval : 150,
            maxInterval : 250
        });

        const reelDivider = new PPReelDivider({
            layer : PixiesVsPiratesGameConfig.instance.LAYERS.REEL_DIVIDER.name,
            texturesGetter : (index:number) => {return GameResources.getTextures("reelDivider")},
            positions : [
                [GameConfig.instance.REEL_AREA_POS_X + PixiesVsPiratesGameConfig.instance.REEL_AREA_SIDE_BORDER + GameConfig.instance.SYMBOL_WIDTH, GameConfig.instance.REEL_AREA_POS_Y + PixiesVsPiratesGameConfig.instance.REEL_AREA_TOP_BORDER - 70],
                [GameConfig.instance.REEL_AREA_POS_X + PixiesVsPiratesGameConfig.instance.REEL_AREA_SIDE_BORDER + GameConfig.instance.SYMBOL_WIDTH * 2, GameConfig.instance.REEL_AREA_POS_Y + PixiesVsPiratesGameConfig.instance.REEL_AREA_TOP_BORDER - 70],
                [GameConfig.instance.REEL_AREA_POS_X + PixiesVsPiratesGameConfig.instance.REEL_AREA_SIDE_BORDER + GameConfig.instance.SYMBOL_WIDTH * 3, GameConfig.instance.REEL_AREA_POS_Y + PixiesVsPiratesGameConfig.instance.REEL_AREA_TOP_BORDER - 70],
                [GameConfig.instance.REEL_AREA_POS_X + PixiesVsPiratesGameConfig.instance.REEL_AREA_SIDE_BORDER + GameConfig.instance.SYMBOL_WIDTH * 4, GameConfig.instance.REEL_AREA_POS_Y + PixiesVsPiratesGameConfig.instance.REEL_AREA_TOP_BORDER - 70],
                [GameConfig.instance.REEL_AREA_POS_X + PixiesVsPiratesGameConfig.instance.REEL_AREA_SIDE_BORDER + GameConfig.instance.SYMBOL_WIDTH * 5, GameConfig.instance.REEL_AREA_POS_Y + PixiesVsPiratesGameConfig.instance.REEL_AREA_TOP_BORDER - 70]
            ]
        });

        const spinEffect = new SpinEffects();

        StageManager.legacyScaling = true;
    };

    constructor() {
        if(PixiesVsPiratesGameModuleConfig.instance) {
            throw new Error("PixiesVsPiratesGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}